<template>
    <div class="flex flex-col mx-auto w-full p-12 lg:p-24 mb-12 text-left" style="max-width: 1400px;" id="supporter">
        <h2 class="font-written text-4xl">Vielen Dank</h2>
        <p class="text-lg text-gray-500 mt-3">an unsere Unterstützer</p>
        <div class="flex flex-wrap gap-2 mt-5">
            <template v-for="i in supporter" :key="i">
                <img :src="`/assets/supporter/${i}.webp`" style="clip-path: polygon(2% 2%, 98% 2%, 98% 98%, 2% 98%)" class="w-5/12 sm:w-auto" draggable="false" :alt="`Logo von ${i}`">
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "Supporter",
    data() {
        return {
            supporter: [
                "bloßholz",
                "agrar-eg-guthmannshausen",
                "agrar-eg-rastenberg",
                "bht",
                "harsch",
                "komed",
                "partyservice",
                "taxi-rieger",
                "weilepp",
            ]
        }
    }
}
</script>